import { registerComponent } from '../app'

const PolicyNav = (scope, el) => {
	const props = {
		openClass: 'open'
	}

	el.addEventListener('click', e => {
		e.target.classList.contains('active') ? e.preventDefault() : null
		el.classList.toggle(props.openClass)
	})
}

registerComponent('policy-nav', PolicyNav)
